import { TARGET } from "../constants/target.qwik.mjs";
import { isBrowser } from "../functions/is-browser.qwik.mjs";
import { setCookie, getCookieSync } from "./cookie.qwik.mjs";
import { noSerializeWrapper } from "./no-serialize-wrapper.qwik.mjs";
const USER_ATTRIBUTES_COOKIE_NAME = "builder.userAttributes";
function createUserAttributesService() {
  let canTrack = true;
  const subscribers = /* @__PURE__ */ new Set();
  return {
    setUserAttributes(newAttrs) {
      if (!isBrowser())
        return;
      const userAttributes = {
        ...this.getUserAttributes(),
        ...newAttrs
      };
      setCookie({
        name: USER_ATTRIBUTES_COOKIE_NAME,
        value: JSON.stringify(userAttributes),
        canTrack
      });
      subscribers.forEach((callback) => callback(userAttributes));
    },
    getUserAttributes() {
      if (!isBrowser())
        return {};
      return JSON.parse(getCookieSync({
        name: USER_ATTRIBUTES_COOKIE_NAME,
        canTrack
      }) || "{}");
    },
    subscribeOnUserAttributesChange(callback, { fireImmediately } = {}) {
      subscribers.add(callback);
      if (fireImmediately)
        callback(this.getUserAttributes());
      return noSerializeWrapper(function() {
        subscribers.delete(callback);
      });
    },
    setCanTrack(value) {
      canTrack = value;
    }
  };
}
let _userAttributesService;
if (isBrowser() && TARGET === "qwik") {
  if (!window.__BUILDER_USER_ATTRIBUTES_SERVICE__)
    window.__BUILDER_USER_ATTRIBUTES_SERVICE__ = createUserAttributesService();
  _userAttributesService = window.__BUILDER_USER_ATTRIBUTES_SERVICE__;
} else
  _userAttributesService = createUserAttributesService();
const userAttributesService = _userAttributesService;
const setClientUserAttributes = (attributes) => {
  userAttributesService.setUserAttributes(attributes);
};
export {
  USER_ATTRIBUTES_COOKIE_NAME,
  createUserAttributesService,
  setClientUserAttributes,
  userAttributesService
};
